<template>
	<div>
		<!-- If modal have a "pui-select" or "pui-date-field", set property :overflow="false" -->
		<!-- If fixed width is needed, set property :widthDialog="XXX" -->
		<pui-modal-dialog-form
			:titleText="$t('action.userapp.reset2FASecretAction')"
			:modelName="modelName"
			:dialogName="reset2FASecretModal"
			:onOk="onOkReset2FASecretModal"
		>
			<template slot="message">
					<v-row dense>
						{{$t('modal.userapp.reset2FASecretDesc')}}
					</v-row>
			</template>
		</pui-modal-dialog-form>
	</div>
</template>

<script>
export default {
	name: 'userApp-modals',
	data() {
		return {
			reset2FASecretModal: 'reset2FASecretAction'
		};
	},
	props: {
		modelName: {
			required: true,
			type: String
		}
	},
	methods: {
		onOkReset2FASecretModal(modalData) {
			const params = {
				usr: modalData.usr,
			};

			const url = this.$store.getters.getModelByName(this.modelName).url.reset2FASecret;
			var title = this.$puiI18n.t('puiaction.notifyTitle') + ' > ' + this.$puiI18n.t('action.userapp.reset2FASecretAction');
			return new Promise((resolve) => {
				this.$puiRequests.postRequest(
					url,
					null,
					(response) => {
						// Valid response, do code and close modal
						console.log(response);
						this.$puiNotify.success(this.$puiI18n.t('puiaction.notifySuccess'), title);
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
						resolve(true);
					},
					(e) => {
						// Error response, do code and not close modal
						let message = this.$puiI18n.t('puiaction.notifyError');
						if (e.response && e.response.data) {
							message = e.response.data.message;
						}
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
						this.$puiNotify.error(message, title);
						resolve(false);
					},
					null,
					params
				);
			});
		}
	}
};
</script>
